import { render, staticRenderFns } from "./InvoiceTab.vue?vue&type=template&id=e2427f4c&scoped=true"
import script from "./InvoiceTab.vue?vue&type=script&lang=js"
export * from "./InvoiceTab.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTab.vue?vue&type=style&index=0&id=e2427f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2427f4c",
  null
  
)

export default component.exports